// extracted by mini-css-extract-plugin
export var brand = "_bo-9";
export var compact = "_bo-6";
export var extraSmall = "_bo-7";
export var icon = "_bo-0";
export var large = "_bo-4";
export var light = "_bo-1";
export var medium = "_bo-5";
export var outline = "_bo-b";
export var primaryDark = "_bo-a";
export var primaryLight = "_bo-8";
export var primaryModern = "_bo-c";
export var success = "_bo-2";
export var successSolid = "_bo-3";